import Constants from '@/Constants';
import http from '@/services/HttpService';
import { call, delay, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import {
    deleteSearchHistoryFailure,
    deleteSearchHistorySuccess,
    getSearchHistoryFailure,
    getSearchHistorySuccess,
    getSearchSuggestionsFailure,
    getSearchSuggestionsSuccess,
} from './action';
import { SearchTypes } from './types';

export function* getSearchHistoryRequest() {
    try {
        yield delay(1000);
        const path = Constants.PERSON_SEARCH_HISTORY_URI;
        const response = yield call(http.get, path);
        yield put(getSearchHistorySuccess(response.data));
    } catch (error) {
        yield put(getSearchHistoryFailure());
    }
}

export function* deleteSearchHistoryRequest() {
    try {
        const path = Constants.PERSON_SEARCH_HISTORY_URI;
        yield call(http.delete, path);
        yield put(deleteSearchHistorySuccess());
    } catch (error) {
        yield put(deleteSearchHistoryFailure());
    }
}

export function* getSearchSuggestionsRequest(action: PayloadAction<SearchTypes.GET_SEARCH_SUGGESTIONS_REQUEST, string>) {
    try {
        const queryParams: string = `?&term=${action.payload}`;
        const response = yield call(http.get, Constants.CAST_SUGGESTIONS_URI + queryParams);
        yield put(getSearchSuggestionsSuccess(response.data));
    } catch (error) {
        yield put(getSearchSuggestionsFailure());
    }
}
